export default {"src":"/_next/static/media/amex-gray.0db3aeb0.svg","height":23,"width":42,"blurWidth":0,"blurHeight":0};